<template>
  <v-list-item>
    <v-list-item-content>
      <v-list-item-title class="text-wrap">Изменить ntp-адрес (RV-3434)</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action>
      <v-dialog v-model="isNTP" persistent max-width="400">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" class="text-none" :disabled="!showSelectButton" rounded>
            Выбрать
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Изменить ntp-адрес (RV-3434)</v-card-title>
          <v-text-field
            ref="ntpAddress"
            v-model="ntpAddress"
            label="Введите ntp-адрес"
            type="string"
            class="pa-5"
            outlined
            dense
            :disabled="selectedFromDns === true"
            hide-details
          ></v-text-field>
          <v-checkbox
            label="Определение DNS"
            append-icon="mdi-information-outline"
            class="pt-0 pb-2 pl-4"
            style="display: inline-flex;"
            v-model="selectedFromDns"
            @click:append="infoFromDns = !infoFromDns"
          >
          </v-checkbox>
          <v-col
            v-if="infoFromDns"
            class="pt-0"
          >
            <p>Если определить DNS, тогда определяется DNS который установлен на устройстве, добавляется +2 в конец адреса, и загружается это значение в ntp адрес.</p>
            <p>При определение DNS включено, нельзя вводить ntp-адрес.</p>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              class="text-none"
              @click="isNTP = false"
              :loading="loading"
            >
              Отменить
            </v-btn>
            <v-btn
              color="success"
              class="text-none"
              @click="updateNtp"
              :loading="loading"
            >
              Установить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogResult" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Результат
          </v-card-title>
          <v-card-text>
            <v-col v-if="issetRightDoorphones()">
              <h3>Успешно изменён на домофонах:</h3>
              <ul>
                <li v-for="(doorphone, index) in updateResult.right_doorphones" :key="index">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
            <v-col v-if="issetFailDoorphones()">
              <div v-for="(error, index) in updateResult.errors" :key="index">
                <h4 class="pb-2">{{ error }}</h4>
              </div>
              <h3>Не удалось изменить на домофонах:</h3>
              <ul>
                <li v-for="(doorphone, index) in updateResult.fail_doorphones" :key="index">
                  {{ doorphone.id }} - {{ doorphone.address }}, п.{{ doorphone.entrance }}
                </li>
              </ul>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogResult = false"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ntpAddress',
  props: ['doorphones'],
  data () {
    return {
      isNTP: false,
      ntpAddress: '',
      selectedFromDns: false,
      dialogResult: false,
      infoFromDns: false,
      loading: false,
      updateResult: {},
    };
  },
  computed: {
    showSelectButton () {
      return this.doorphones.every(item => item.model_id === 5);
    },
  },
  methods: {
    ...mapActions({
      updateNtpAddress: 'Doorphone/updateNtpAddress',
    }),
    updateNtp () {
      this.$refs.ntpAddress.validate(true);
      if (!this.selectedFromDns && this.ntpAddress === '') {
        this.$flash_danger('Введите ntp-адрес');
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
        const selectedDoorphoneId = this.doorphones.map(doorphone => { return doorphone.id; });

        const selectedTmp = {
          from_dns: this.selectedFromDns,
          doorphones: selectedDoorphoneId,
        };
        if (!this.selectedFromDns) {
          selectedTmp.ntp_address = this.ntpAddress;
        }
        this.updateNtpAddress({
          selectedTmp: selectedTmp,
        })
          .then((res) => {
            this.ntpAddress = '';
            this.isNTP = false;
            this.updateResult = res;
            this.dialogResult = true;
          })
          .catch(e => {
            this.$flash_warning('Не удалось обновить ntp-адрес');
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    issetRightDoorphones () {
      return this.updateResult.right_doorphones && this.updateResult.right_doorphones.length > 0;
    },
    issetFailDoorphones () {
      return this.updateResult.fail_doorphones && this.updateResult.fail_doorphones.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
